import React from "react";

const RememberMe = ({ checked, onChange }) => {
  return (
    <div className="containerRememberMe">
      <input
        type="checkbox"
        className="rememberMeInput"
        name="rememberMe"
        checked={checked}
        onChange={onChange}
      />
      <span>Se souvenir de moi</span>
    </div>
  );
};

export default RememberMe;
